import React, { useRef, useEffect, useState } from 'react';
import ReactSlider from 'react-slider';

const Renderinputrange = (props) => {
  const sliderRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(props.value);


  useEffect(() => {
    setDisplayValue(props.value);
  }, [props.value]);

  // Determine max value and marks based on instrument type
  const maxValue = props.instrumentType === "VVI" ? 5 : 10;
  const marks = props.instrumentType === "VVI" 
    ? [0, 1, 2, 3, 4, 5]  // VVI marks
    : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];  // Default marks

  const handleMarkClick = (value) => {
    props.handleInputRange(value);
  };

  const calculateLeftPosition = (value) => {
    const percentage = (value / maxValue) * 100;
    return props.instrumentType === "VVI" ? percentage * 0.2 : percentage * 0.1;
  };

  return (
    <div ref={sliderRef} style={{ padding: '40px 10px 20px', background: '#F0F0F0', borderRadius: '10px', position: 'relative', marginTop: '20px' }}>
      <ReactSlider
        value={props.value}
        min={0}
        max={maxValue}
        step={0.1}
        onChange={(value) => {
          props.handleInputRange(value);
          setDisplayValue(value);
        }}
        renderTrack={(props, state) => <div {...props} className="slider-track" />}
        renderThumb={(props, state) => (
          <div {...props} className="slider-thumb">
            <div 
              className="value-display"
              style={{
                left: `${calculateLeftPosition(displayValue)}%`
              }}
            >
              {displayValue.toFixed(1)}
              <div className="value-arrow"></div>
            </div>
          </div>
        )}
        renderMark={(props) => <div {...props} className="slider-mark" />}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
        {marks.map((mark) => (
          <span 
            key={mark} 
            style={{ fontSize: '12px', color: '#888', cursor: 'pointer' }}
            onClick={() => handleMarkClick(mark)}
          >
            {mark}
          </span>
        ))}
      </div>
      <style jsx>{`
        .slider-track {
          top: 0;
          bottom: 0;
          background: #32c536;
          border-radius: 999px;
          height: 4px;
          cursor: pointer;
        }
        .slider-thumb {
          background: white;
          border: 2px solid #32c536;
          border-radius: 50%;
          cursor: grab;
          height: 20px;
          width: 20px;
          top: -8px;
          display: flex;
          justify-content: center;
          align-items: center;
          outline: none;
        }
        .value-display {
          position: absolute;
          top: -40px;
          transform: translateX(-50%);
          background: #32c536;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          white-space: nowrap;
          z-index: 2;
        }
        .value-arrow {
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid #32c536;
        }
        .slider-mark {
          cursor: pointer;
          top: 6px;
          width: 1px;
          height: 8px;
          background-color: #aaa;
        }
      `}</style>
    </div>
  );
};

export default Renderinputrange;


// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/input-range.jsx